import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type Incident } from '../../api/observability';

export function IncidentCenterPage() {
  const [incidents, setIncidents] = useState<Incident[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.incidents().then(setIncidents).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Incident Center</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-4 divide-y rounded-lg border dark:border-slate-700">
        {incidents.map((i) => (
          <li key={i.id} className="px-4 py-3">
            <div className="flex items-center justify-between">
              <span className="font-medium">{i.title}</span>
              <span className={`text-sm capitalize ${i.severity === 'critical' ? 'text-red-600' : 'text-slate-600'}`}>{i.severity}</span>
            </div>
            <p className="mt-1 text-sm text-slate-500">{i.description}</p>
            <p className="mt-1 text-xs text-slate-400">Status: {i.status} · {new Date(i.created_at).toLocaleString()}</p>
          </li>
        ))}
        {incidents.length === 0 && !error && <li className="px-4 py-6 text-center text-slate-500">No incidents</li>}
      </ul>
    </div>
  );
}
